import React from 'react';

import Coachmark from '../coachmark/coachmark';

import styles from './close-cta.module.scss';

function CloseCta() {
  return (
    <>
      <div className={styles.closeCtaContainer}>
        <Coachmark
          position="right"
          showArrow={true}
          label={
            <>
              To continue, select <b>Mark as completed</b>. Close full screen first if using.
            </>
          }
        />
      </div>
      <div className={styles.mobileCloseCtaContainer}>
        <Coachmark
          position="right"
          showArrow={false}
          label={
            <>
              To continue, select <b>Mark as completed.</b>
            </>
          }
        />
      </div>
    </>
  );
}

export default CloseCta;
